import React from "react";
import { Navigate} from "react-router-dom";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("access_token");
  const isAuthenticated = token !== null && token !== "";
  return isAuthenticated ? children : <Navigate to="/" />;
}
